export const lightBrandColors = {
    // PRIMARY
    brandPrimary1: 'var(--theme-ui-colors-chocoBlue)',
    brandPrimary2: 'var(--theme-ui-colors-chocoMidBlue)',
    brandPrimary3: 'var(--theme-ui-colors-chocoDarkBlue)',
    brandPrimary4: 'var(--theme-ui-colors-chocoLightBlue)',
    brandPrimary5: 'var(--theme-ui-colors-chocoVeryLightBlue)',
    // SECONDARY
    brandSecondary1: 'var(--theme-ui-colors-orange)',
    brandSecondary2: 'var(--theme-ui-colors-squash)',
    brandSecondary3: 'var(--theme-ui-colors-coconut)',
    brandSecondary4: 'var(--theme-ui-colors-banana)',
    brandSecondary5: 'var(--theme-ui-colors-plum)',
    brandSecondary6: 'var(--theme-ui-colors-pomegranate)',
    brandSecondary7: 'var(--theme-ui-colors-gojiBerry)',
    brandSecondary8: 'var(--theme-ui-colors-lychee)',
    brandSecondary9: 'var(--theme-ui-colors-honeyDew)',
    brandSecondary10: 'var(--theme-ui-colors-spinach)',
    brandSecondary11: 'var(--theme-ui-colors-cucumber)',
    brandSecondary12: 'var(--theme-ui-colors-mint)',
};
export const darkBrandColors = {
    // PRIMARY
    brandPrimary1: 'var(--theme-ui-colors-chocoBlue)',
    brandPrimary2: 'var(--theme-ui-colors-chocoMidBlue)',
    brandPrimary3: 'var(--theme-ui-colors-chocoDarkBlue)',
    brandPrimary4: 'var(--theme-ui-colors-chocoLightBlue)',
    brandPrimary5: 'var(--theme-ui-colors-chocoVeryLightBlue)',
    // SECONDARY
    brandSecondary1: 'var(--theme-ui-colors-orange)',
    brandSecondary2: 'var(--theme-ui-colors-squash)',
    brandSecondary3: 'var(--theme-ui-colors-coconut)',
    brandSecondary4: 'var(--theme-ui-colors-banana)',
    brandSecondary5: 'var(--theme-ui-colors-plum)',
    brandSecondary6: 'var(--theme-ui-colors-pomegranate)',
    brandSecondary7: 'var(--theme-ui-colors-gojiBerry)',
    brandSecondary8: 'var(--theme-ui-colors-lychee)',
    brandSecondary9: 'var(--theme-ui-colors-honeyDew)',
    brandSecondary10: 'var(--theme-ui-colors-spinach)',
    brandSecondary11: 'var(--theme-ui-colors-cucumber)',
    brandSecondary12: 'var(--theme-ui-colors-mint)',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJhbmRDb2xvcnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvc2VtYW50aWNDb2xvcnMvYnJhbmRDb2xvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLE1BQU0sZ0JBQWdCLEdBQUc7SUFDOUIsVUFBVTtJQUNWLGFBQWEsRUFBRSxrQ0FBa0M7SUFDakQsYUFBYSxFQUFFLHFDQUFxQztJQUNwRCxhQUFhLEVBQUUsc0NBQXNDO0lBQ3JELGFBQWEsRUFBRSx1Q0FBdUM7SUFDdEQsYUFBYSxFQUFFLDJDQUEyQztJQUUxRCxZQUFZO0lBQ1osZUFBZSxFQUFFLCtCQUErQjtJQUNoRCxlQUFlLEVBQUUsK0JBQStCO0lBQ2hELGVBQWUsRUFBRSxnQ0FBZ0M7SUFDakQsZUFBZSxFQUFFLCtCQUErQjtJQUNoRCxlQUFlLEVBQUUsNkJBQTZCO0lBQzlDLGVBQWUsRUFBRSxvQ0FBb0M7SUFDckQsZUFBZSxFQUFFLGtDQUFrQztJQUNuRCxlQUFlLEVBQUUsK0JBQStCO0lBQ2hELGVBQWUsRUFBRSxpQ0FBaUM7SUFDbEQsZ0JBQWdCLEVBQUUsZ0NBQWdDO0lBQ2xELGdCQUFnQixFQUFFLGlDQUFpQztJQUNuRCxnQkFBZ0IsRUFBRSw2QkFBNkI7Q0FDaEQsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBNEI7SUFDdEQsVUFBVTtJQUNWLGFBQWEsRUFBRSxrQ0FBa0M7SUFDakQsYUFBYSxFQUFFLHFDQUFxQztJQUNwRCxhQUFhLEVBQUUsc0NBQXNDO0lBQ3JELGFBQWEsRUFBRSx1Q0FBdUM7SUFDdEQsYUFBYSxFQUFFLDJDQUEyQztJQUUxRCxZQUFZO0lBQ1osZUFBZSxFQUFFLCtCQUErQjtJQUNoRCxlQUFlLEVBQUUsK0JBQStCO0lBQ2hELGVBQWUsRUFBRSxnQ0FBZ0M7SUFDakQsZUFBZSxFQUFFLCtCQUErQjtJQUNoRCxlQUFlLEVBQUUsNkJBQTZCO0lBQzlDLGVBQWUsRUFBRSxvQ0FBb0M7SUFDckQsZUFBZSxFQUFFLGtDQUFrQztJQUNuRCxlQUFlLEVBQUUsK0JBQStCO0lBQ2hELGVBQWUsRUFBRSxpQ0FBaUM7SUFDbEQsZ0JBQWdCLEVBQUUsZ0NBQWdDO0lBQ2xELGdCQUFnQixFQUFFLGlDQUFpQztJQUNuRCxnQkFBZ0IsRUFBRSw2QkFBNkI7Q0FDaEQsQ0FBQyJ9